import React, { useState } from 'react';
import logo from "../src/assets/Logo English.png";

const styles = {
  header: {
    width: "100%",
    backgroundColor: "#b366b3",
    color: "white",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    position: "fixed",  // Make the header fixed
    top: 0,             // Stick it to the top of the viewport
    zIndex: 1000, 
  },
  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    maxWidth: "1000px", // Example max-width to prevent overly wide layout
    margin: "0 auto",
    position: "relative",
  },
  logoContainer: {
    flexShrink: 0,
    zIndex: 1001,
  },
  logo: {
    height: "auto",
    maxHeight: "95px", // Adjust maximum logo height
    width: "auto",
    maxWidth: "100px", // Adjust maximum logo width
  },
  navLinks: {
    display: "flex",
    gap: "15px",
  },
  navLinksMobile: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    backgroundColor: "#b366b3",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "30px",
    transform: "translateX(-100%)",
    transition: "transform 0.3s ease-in-out",
    zIndex: 999,
  },
  navLinksMobileOpen: {
    transform: "translateX(0)",
  },
  link: {
    textDecoration: "none",
    color: "white",
    fontSize: "15px",
    fontWeight: "bold",
    padding: "5px 10px",
    transition: "background-color 0.3s",
    borderRadius: "4px",
  },
  linkMobile: {
    fontSize: "18px",
    padding: "15px 20px",
    textAlign: "center",
    minWidth: "200px",
  },
  linkHover: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  hamburger: {
    display: "none",
    flexDirection: "column",
    cursor: "pointer",
    padding: "5px",
    zIndex: 1001,
  },
  hamburgerLine: {
    width: "25px",
    height: "3px",
    backgroundColor: "white",
    margin: "3px 0",
    transition: "all 0.3s ease",
    borderRadius: "2px",
  },
  hamburgerLineOpen1: {
    transform: "rotate(45deg) translate(6px, 6px)",
  },
  hamburgerLineOpen2: {
    opacity: 0,
  },
  hamburgerLineOpen3: {
    transform: "rotate(-45deg) translate(6px, -6px)",
  },
  centeredTitle: {
    backgroundColor: "#ffffff",
    color: "#800080",
    textAlign: "center",
    padding: "6px 0",
    fontWeight: "bold",
    fontSize: "16px",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 998,
    opacity: 0,
    visibility: "hidden",
    transition: "all 0.3s ease",
  },
  overlayOpen: {
    opacity: 1,
    visibility: "visible",
  },
};

// Media query styles
const mediaQueries = {
  mobile: window.innerWidth <= 768,
};

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle window resize
  React.useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLinkHover = (e) => {
    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
  };

  const handleLinkLeave = (e) => {
    e.target.style.backgroundColor = "transparent";
  };

  return (
    <div>
      {/* Overlay for mobile menu */}
      {isMobile && (
        <div
          style={{
            ...styles.overlay,
            ...(isMenuOpen ? styles.overlayOpen : {}),
          }}
          onClick={closeMenu}
        />
      )}

      <header style={styles.header}>
        <div style={styles.navbar}>
          {/* Logo */}
          <div style={styles.logoContainer}>
            <img
              src={logo}
              alt="Logo"
              style={styles.logo}
            />
          </div>

          {/* Desktop Navigation Links */}
          <nav style={{
            ...styles.navLinks,
            display: isMobile ? "none" : "flex"
          }}>
            <a 
              href="/" 
              style={styles.link}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Home
            </a>
            <a 
              href="about1" 
              style={styles.link}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              About Us
            </a>
            <a 
              href="directors" 
              style={styles.link}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Organization
            </a>
            <a 
              href="financial1" 
              style={styles.link}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Financial Details
            </a>
            <a 
              href="services1" 
              style={styles.link}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Our Services
            </a>
            <a 
              href="subsidiary1" 
              style={styles.link}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Subsidiary
            </a>
             
            <a 
              href="gallery" 
              style={styles.link}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Gallery
            </a>
            <a 
              href="contact1" 
              style={styles.link}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Contact Us
            </a>
          </nav>

          {/* Hamburger Menu */}
          <div 
            style={{
              ...styles.hamburger,
              display: isMobile ? "flex" : "none"
            }} 
            onClick={toggleMenu}
          >
            <span
              style={{
                ...styles.hamburgerLine,
                ...(isMenuOpen ? styles.hamburgerLineOpen1 : {}),
              }}
            />
            <span
              style={{
                ...styles.hamburgerLine,
                ...(isMenuOpen ? styles.hamburgerLineOpen2 : {}),
              }}
            />
            <span
              style={{
                ...styles.hamburgerLine,
                ...(isMenuOpen ? styles.hamburgerLineOpen3 : {}),
              }}
            />
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobile && (
          <nav
            style={{
              ...styles.navLinksMobile,
              ...(isMenuOpen ? styles.navLinksMobileOpen : {}),
            }}
          >
            <a 
              href="/" 
              style={{...styles.link, ...styles.linkMobile}}
              onClick={closeMenu}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Home
            </a>
            <a 
              href="about1" 
              style={{...styles.link, ...styles.linkMobile}}
              onClick={closeMenu}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              About Us
            </a>
            <a 
              href="directors" 
              style={{...styles.link, ...styles.linkMobile}}
              onClick={closeMenu}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Organization
            </a>
            <a 
              href="financial1" 
              style={{...styles.link, ...styles.linkMobile}}
              onClick={closeMenu}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Financial Details
            </a>
            <a 
              href="services1" 
              style={{...styles.link, ...styles.linkMobile}}
              onClick={closeMenu}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Our Services
            </a>
            <a 
              href="subsidiary1" 
              style={{...styles.link, ...styles.linkMobile}}
              onClick={closeMenu}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Subsidiary
            </a>
            <a 
              href="gallery" 
              style={{...styles.link, ...styles.linkMobile}}
              onClick={closeMenu}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Gallery
            </a>
            <a 
              href="contact1" 
              style={{...styles.link, ...styles.linkMobile}}
              onClick={closeMenu}
              onMouseEnter={handleLinkHover}
              onMouseLeave={handleLinkLeave}
            >
              Contact Us
            </a>
          </nav>
        )}

        {/* Centered Title */}
        <div style={{
          ...styles.centeredTitle,
          fontSize: isMobile ? "12px" : "16px",
          padding: isMobile ? "4px 10px" : "6px 0"
        }}>
          <h3 style={{ margin: 0 }}>Shri Saraswathi Credit Souharda Sahakari Sangha Limited. Puttur, DK</h3>
        </div>
      </header>
      
    </div>
  );
}